import type { AxiosRequestConfig } from 'axios'
import { store } from 'src/client'
import { RequestConfig } from 'src/queries/requestConfig.models'
import {
  selectAuthedFormApiRequestConfig,
  selectAuthedJsonAgentRequestConfig,
  selectAuthedJsonApiRequestConfig,
  selectAuthedJsonVaultRequestConfig,
  selectCspAuthedJsonApiRequestConfig,
  selectUnauthedJsonAddressulatorRequestConfig,
  selectUnauthedJsonApiRequestConfig,
} from 'src/redux/selectors/axios.selectors'

export { RequestConfig } from 'src/queries/requestConfig.models'

export const getRequestConfig = (
  config?: RequestConfig,
): AxiosRequestConfig => {
  const state = store.getState()

  switch (config) {
    case RequestConfig.Vault:
      return selectAuthedJsonVaultRequestConfig(state)
    case RequestConfig.Unauthed:
      return selectUnauthedJsonApiRequestConfig(state)
    case RequestConfig.Form:
      return selectAuthedFormApiRequestConfig(state)
    case RequestConfig.Agent:
      return selectAuthedJsonAgentRequestConfig(state)
    case RequestConfig.Addressulator:
      return selectUnauthedJsonAddressulatorRequestConfig(state)
    case RequestConfig.Csp:
      return selectCspAuthedJsonApiRequestConfig(state)
    case RequestConfig.Default:
    default:
      return selectAuthedJsonApiRequestConfig(state)
  }
}
